webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Hello__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Verzetten__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Verzetten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Verzetten__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Shop__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Shop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Shop__);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hello___default.a
  }, {
    path: '/verzetten',
    name: 'Verzetten',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Verzetten___default.a
  }, {
    path: '/shop',
    name: 'Shop',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Shop___default.a
  }]
}));

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(11)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(5),
  /* template */
  __webpack_require__(19),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(2);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  data: function data() {
    return {
      assortiment: [{ id: 1, naam: 'Cassettes en kettingbladen' }, { id: 2, naam: 'Crankstellen en pedalen' }, { id: 3, naam: 'Kettingbladen' }, { id: 4, naam: 'Groepsets en onderdelen' }, { id: 5, naam: 'Remmen' }, { id: 6, naam: 'Wielen' }, { id: 7, naam: 'Sturen, stuurpennen, zadelpennen' }, { id: 8, naam: 'Banden' }]
    };
  }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'verzetten',
  created: function created() {},
  data: function data() {
    return {
      assortiment: [{ naam: 'Cassettes en kettingbladen' }, { naam: 'Crankstellen en pedalen' }, { naam: 'Kettingbladen' }, { naam: 'Groepsets en onderdelen' }, { naam: 'Remmen' }, { naam: 'Wielen' }, { naam: 'Sturen, stuurpennen, zadelpennen' }, { naam: 'Banden' }]
    };
  },

  methods: {},
  watch: {}
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'verzetten',
  created: function created() {
    this.updateVerzetten();
  },
  data: function data() {
    return {
      omtrekUitLijst: null,
      limietUitLijst: null,
      limieten: [{
        tekst: 'NL-Weg/Baan Cat 1,2',
        limiet: 5.46
      }, {
        tekst: 'NL-Weg/Baan Cat 3,4',
        limiet: 5.78
      }, {
        tekst: 'NL-Weg/Baan Cat 5,6',
        limiet: 6.14
      }, {
        tekst: 'NL-Weg/Baan Cat 7',
        limiet: 6.55
      }, {
        tekst: 'NL-Weg/Baan Cat Nieuwelingen',
        limiet: 7.01
      }, {
        tekst: 'NL-Weg/Baan Cat Junioren',
        limiet: 7.93
      }, {
        tekst: 'NL-Veld Cat 1,2',
        limiet: 5.22
      }, {
        tekst: 'NL-Veld Cat 3,4',
        limiet: 5.52
      }, {
        tekst: 'NL-Veld Cat 5,6',
        limiet: 5.87
      }, {
        tekst: 'NL-Veld Cat 7',
        limiet: 6.26
      }, {
        tekst: 'NL-Veld Cat 1,2 (2019)',
        limiet: 5.61
      }, {
        tekst: 'NL-Veld Cat 3,4 (2019)',
        limiet: 5.94
      }, {
        tekst: 'NL-Veld Cat 5,6 (2019)',
        limiet: 6.31
      }, {
        tekst: 'NL-Veld Cat 7 (2019)',
        limiet: 6.73
      }, {
        tekst: 'DE-Rad/Bahn U11',
        limiet: 5.66
      }, {
        tekst: 'DE-Rad U13',
        limiet: 5.66
      }, {
        tekst: 'DE-Bahn U13',
        limiet: 6.10
      }, {
        tekst: 'DE-Rad U15',
        limiet: 6.10
      }, {
        tekst: 'DE-Bahn U15',
        limiet: 6.45
      }, {
        tekst: 'DE-Rad/Bahn U17',
        limiet: 7.01
      }, {
        tekst: 'DE-Rad U19',
        limiet: 7.93
      }, {
        tekst: 'FR-Poussin/Pupille',
        limiet: 5.6
      }, {
        tekst: 'FR-Benjamin',
        limiet: 6.4
      }, {
        tekst: 'FR-Minime',
        limiet: 7.01
      }, {
        tekst: 'DAN U11/U13 weg',
        limiet: 5.89
      }, {
        tekst: 'DAN U15 weg',
        limiet: 6.35
      }, {
        tekst: 'BE U9/U10/U11 weg',
        limiet: 5.45
      }, {
        tekst: 'BE U12/U13 weg',
        limiet: 5.69
      }, {
        tekst: 'BE U14/U15 weg',
        limiet: 6.4
      }],
      banden: [{
        naam: 'Vittoria 700x22C',
        omtrek: 2.105
      }, {
        naam: 'Specialized 700x24C',
        omtrek: 2.123
      }, {
        naam: 'Vredestein 700x23C',
        omtrek: 2.115
      }, {
        naam: 'Vittoria 700x25C',
        omtrek: 2.13
      }, {
        naam: '700x26C',
        omtrek: 2.14
      }, {
        naam: '700x28C',
        omtrek: 2.15
      }, {
        naam: 'Cross 33mm',
        omtrek: 2.17
      }],
      verzetten: [],
      omtrek: null,
      limiet: null,
      kransMin: 11,
      kransMax: 18,
      bladMin: 28,
      bladMax: 52,
      narrowWide: false,
      assortiment: [{ naam: 'Cassettes en kettingbladen' }, { naam: 'Crankstellen en pedalen' }, { naam: 'Kettingbladen' }, { naam: 'Groepsets en onderdelen' }, { naam: 'Remmen' }, { naam: 'Wielen' }, { naam: 'Sturen, stuurpennen, zadelpennen' }, { naam: 'Banden' }]
    };
  },

  methods: {
    updateVerzetten: function updateVerzetten() {
      if (Number(this.$data.limiet) === 0 || Number(this.$data.omtrek) === 0) {
        this.$data.verzetten = [];
      } else {
        this.$data.verzetten = [];
        for (var i = this.$data.kransMin; i <= this.$data.kransMax; i++) {
          var b = Math.floor(this.$data.limiet / this.$data.omtrek * i);
          if (this.$data.narrowWide) {
            if (b % 2 === 1) {
              b = b - 1;
            }
          }
          var m = Math.round(1000 * (this.$data.limiet - this.$data.omtrek * b / i)) / 10;
          this.$data.verzetten.push({
            blad: b,
            krans: i,
            marge: m
          });
        }
      }
    }
  },
  watch: {
    omtrekUitLijst: function omtrekUitLijst(val) {
      this.$data.omtrek = val;
    },
    limietUitLijst: function limietUitLijst(val) {
      this.$data.limiet = val;
    },

    omtrek: function omtrek(val) {
      this.updateVerzetten();
    },
    limiet: function limiet(val) {
      this.updateVerzetten();
    },
    narrowWide: function narrowWide(val) {
      this.updateVerzetten();
    }
  }
});

/***/ }),
/* 9 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 10 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 11 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 12 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Logo.367de5c.png";

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(10)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(18),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2c40f2c9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(9)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(17),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0a018b62",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(12)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(20),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6674962e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('h3', [_vm._v("Assortiment")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.assortiment), function(item) {
    return _c('li', {
      staticClass: "list-group-item"
    }, [_vm._v("\n        " + _vm._s(item.naam) + "\n      ")])
  }))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('h3', [_vm._v("Shop")]), _vm._v(" "), _c('p', [_vm._v("We hebben eerder een webshop actief gehad, maar juist voor de jeugdwerk is eigenlijk alles maatwerk.")]), _vm._v(" "), _c('p', [_vm._v("Daarom hebben we ervoor gekozen geen webshop meer actief te hebben, maar dat betekent niet dat we geen \n        jeugd-specifieke artikelen meer kunnen leveren.")]), _vm._v(" "), _c('p', [_vm._v("Neem contact met mij op via info@fietsenmetvictor.nl of +31 85 30 11 500 als je op zoek bent naar een \n          bepaald onderdeel of een oplossing. ")])])
}]}

/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('h3', [_vm._v("Assortiment")]), _vm._v(" "), _c('div', {
    staticClass: "list-group"
  }, _vm._l((_vm.assortiment), function(a) {
    return _c('span', {
      key: a.id,
      staticClass: "list-group-item"
    }, [_vm._v("\n              " + _vm._s(a.naam) + "\n            ")])
  }))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('h3', [_vm._v("Rivkah en Victor")]), _vm._v(" "), _c('p', [_vm._v("Mijn zus Rivkah begon in 2014 met wedstrijden op de weg en daarna in het veld. Ik ben in 2015 in het veld begonnen. ")]), _vm._v(" "), _c('p', [_vm._v("Met onze vader hebben wij in die tijd heel veel ervaring op gedaan.\n          Daarbij hebben we ook heel veel geleerd over technische dingen die bij de jeugd nogal eens mis kunnen gaan.")]), _vm._v(" "), _c('p', [_vm._v("Via deze site bieden wij producten aan waarvan we uit ervaring weten dat die juist voor jeugdrenners handig zijn.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('h3', [_vm._v("Techniek")]), _vm._v(" "), _c('p', [_vm._v("De jeugd sport vaak in de breedte en daarom hebben wij onderdelen en accessoires voor wielrennen, veldrijden, mountainbiken en baanwielrennen.")]), _vm._v(" "), _c('p', [_vm._v("We helpen ook met het afstellen van fietsen, want juist bij jeugd is iedereen verschillend en kan zelfs een kleine aanpassing al\n        een wereld van verschil opleveren.")]), _vm._v(" "), _c('p', [_vm._v("We helpen ook bij het bepalen van de juiste verzetten in combinatie met de gebruikte banden en wij hebben zelf heel goede ervaringen met het\n        rijden met een enkel blad voor.")]), _vm._v(" "), _c('p', [_vm._v("Kinderen hebben vaak moeite met schakelen en onze ervaring is dat ook daarin allerlei oplossingen bestaan, variërend van kiezen voor de juiste shifter\n        het toepassen van een elektronisch schakelsysteem.")])])
}]}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('nav', {
    staticClass: "navbar navbar-default navbar-fixed-top"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('router-link', {
    staticClass: "navbar-left",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "50px"
    },
    attrs: {
      "src": __webpack_require__(13)
    }
  })]), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "myNavbar"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/",
      "active-class": "active",
      "exact": ""
    }
  }, [_c('a', [_vm._v("Home")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/verzetten",
      "active-class": "active"
    }
  }, [_c('a', [_vm._v("Verzetten")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/shop",
      "active-class": "active"
    }
  }, [_c('a', [_vm._v("Shop")])])], 1)])])]), _vm._v(" "), _c('router-view'), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#myNavbar"
    }
  }, [_c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left"
  }, [_c('strong', [_vm._v("Tel")]), _vm._v("\n        +31 85 30 11 500\n        "), _c('strong', [_vm._v("Email")]), _vm._v("\n        info@fietsenmetvictor.nl\n\n\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  })])])
}]}

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('h3', [_vm._v("Rekenmodule")]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "limiet"
    }
  }, [_vm._v("Limiet (m):")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.limiet),
      expression: "limiet",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "limiet"
    },
    domProps: {
      "value": (_vm.limiet)
    },
    on: {
      "change": function($event) {
        _vm.limiet = $event.target.value
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.limietUitLijst),
      expression: "limietUitLijst",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.limietUitLijst = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.limieten), function(l) {
    return _c('option', {
      domProps: {
        "value": l.limiet
      }
    }, [_vm._v(_vm._s(l.tekst))])
  })), _vm._v(" "), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "limiet"
    }
  }, [_vm._v("Wielomtrek (m):")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.omtrek),
      expression: "omtrek",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "limiet"
    },
    domProps: {
      "value": (_vm.omtrek)
    },
    on: {
      "change": function($event) {
        _vm.omtrek = $event.target.value
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.omtrekUitLijst),
      expression: "omtrekUitLijst",
      modifiers: {
        "lazy": true
      }
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.omtrekUitLijst = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.banden), function(l) {
    return _c('option', {
      domProps: {
        "value": l.omtrek
      }
    }, [_vm._v(_vm._s(l.naam))])
  })), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.narrowWide),
      expression: "narrowWide"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.narrowWide) ? _vm._i(_vm.narrowWide, null) > -1 : (_vm.narrowWide)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.narrowWide,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.narrowWide = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.narrowWide = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.narrowWide = $$c
        }
      }
    }
  }), _vm._v("Narrow-Wide")])])])]), _vm._v(" "), _c('label', {
    staticClass: "control-label"
  }, [_vm._v("Mogelijke verzetten:")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.verzetten), function(v) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(v.blad))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(v.krans))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(v.marge))])])
  })], 2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('h3', [_vm._v("Jeugdverzetten")]), _vm._v(" "), _c('p', [_vm._v("Bij wielrennen, veldrijden en op de baan krijgen jeugdrenners te maken met regels die het gebruikte verzet beperken")]), _vm._v(" "), _c('p', [_vm._v("We zien dat dit vaak problemen of uitdagingen oplevert. Hoe werkt het? Voor de categorie en discipline waar je in rijdt,\n        geldt een maximum. Dit is een afstand in centimeters die je met één hele pedaalomwenteling op het zwaarste verzet af mag leggen.")]), _vm._v(" "), _c('p', [_vm._v("Vaak wordt nog gedacht dat alleen maar het verzet van belang is, maar om de maat van de band is van belang.")]), _vm._v(" "), _c('p', [_vm._v("Met een 25mm band is de omtrekt van het wiel groter dan met een 23mm band. En zelfs kan de druk van belang zijn.\n          Dit laatste zie je vooral in het veldrijden, waar vaak met heel lage bandendruk wordt gereden. Ook moet je er\n        rekening mee houden dat de de omtrent ook verschillend kan zijn tussen diverse banden van verschillende types\n      of merken met dezelfde maatvoering")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4"
  }, [_c('h3', [_vm._v("Opmeten")]), _vm._v(" "), _c('p', [_vm._v("Zelfs als je wil gaan rekenen met verzetten, zul je eerst de omtrek van het wiel met band op moeten meten.\n          En het beste doe je dat door met de fiets door een smal gootje te rijden. Ze het ventiel van het achterwiel\n          onder, markeer dat punt en rij dan tot het ventiel weer onder staat. Markeer ook dat punt en meet de afstand\n          tussen beide punten")]), _vm._v(" "), _c('p', [_vm._v("Voor de rekenmodule die hiernaast staat hebben wij een paar banden opgemeten, zodat je een goede indicatie\n            krijgt van de omtrek.")]), _vm._v(" "), _c('p', [_vm._v("In de module kun je ook kiezen tussen 'narrow-wide' en 'normaal' kettingblad. Een narrow-wide kettingblad\n            is gemaakt om zonder derailleur als enkel kettingblad gebruikt te kunnen worden. Dit heeft allerlei voordelen,\n            maar ook één belangrijke beperking: de techniek heeft tot gevolg dat het aantal tanden altijd even is.")]), _vm._v(" "), _c('p', [_vm._v("De module geeft uiteindelijk een goede indicatie, maar zekerheid heb je pas als je alles zelf opmeet of op\n              laat meten. Bij fietsen waar wij verzetten en/of banden monteren, meten wij als dat gevraagd wordt de\n              waardes op.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Blad")]), _vm._v(" "), _c('th', [_vm._v("Krans")]), _vm._v(" "), _c('th', [_vm._v("Marge (cm)")])])
}]}

/***/ })
],[4]);


// WEBPACK FOOTER //
// static/js/app.ec78f4604419f067160c.js